import { render, staticRenderFns } from "./radio-img-button.vue?vue&type=template&id=3d6135a6&"
import script from "./radio-img-button.vue?vue&type=script&lang=js&"
export * from "./radio-img-button.vue?vue&type=script&lang=js&"
import style0 from "./radio-img-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports